import axios from "axios"
import store from "@/store"
import dynamodb from "aws-sdk/clients/dynamodb"

var request = axios.create({
  baseURL: window.location.hostname == "localhost" ? "https://eiu3du1gbi.execute-api.eu-west-2.amazonaws.com/test/" : "https://eiu3du1gbi.execute-api.eu-west-2.amazonaws.com/live/",
  headers: { "Content-Type": "application/json" }
})
var lambda = axios.create({
  baseURL: "/.netlify/functions/"
})

function parseItem(item) {
  if (item.ItemType) {
    var data = item.ItemType.split("#")
    if (data[1]) item.OrderIndex = data[1]

    data = data[0].split("@")
    if (data[1]) item.ParentID = data[1]

    item.ItemType = data[0].replace(/=+$/g, "")
  }

  return item
}

export default {
  getPages: function(type, attributes = "", filter = "", limit = "", order = "") {
    return new Promise((resolve, reject) => {
      request
        .get(
          "getitems?siteid=" +
            store.state.site_id +
            "&itemtype=" +
            type +
            "&attr=ItemID,name,url,image" +
            (attributes ? "," + attributes : "") +
            (limit ? "&limit=" + limit : "") +
            (filter ? "&filter=" + filter : "") +
            (order ? "&orderby=" + order : "")
        )
        .then(response => {
          resolve(response.data.Items.map(item => dynamodb.Converter.unmarshall(item)))
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPageByURL: function(url) {
    return new Promise((resolve, reject) => {
      request
        .get("getpage?siteid=" + store.state.site_id + "&url=" + url)
        .then(response => {
          resolve(parseItem(dynamodb.Converter.unmarshall(response.data.Items[0])))
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getHomePage: function() {
    return new Promise((resolve, reject) => {
      request
        .get("getitem?siteid=" + store.state.site_id + "&itemid=" + store.state.homeID)
        .then(response => resolve(parseItem(dynamodb.Converter.unmarshall(response.data.Item))))
        .catch(error => {
          reject(error)
        })
    })
  },
  getSubPages: function(type, parent) {
    return new Promise((resolve, reject) => {
      request
        .get("getsubs?siteid=" + store.state.site_id + "&itemtype=" + type + "&parent=" + parent + "&attr=ItemID,name,ParentID,url,image,intro")
        .then(response => {
          resolve(response.data.Items.map(item => dynamodb.Converter.unmarshall(item)))
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPageByItemID: function(itemid, attr = "") {
    return new Promise((resolve, reject) => {
      request
        .get("getitem?siteid=" + store.state.site_id + "&itemid=" + itemid + (attr ? "&attr=" + attr : ""))
        .then(response => resolve(parseItem(dynamodb.Converter.unmarshall(response.data.Item))))
        .catch(error => {
          reject(error)
        })
    })
  },
  obitMessage: function(data) {
    return new Promise((resolve, reject) => {
      lambda
        .post("post-message", data)
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          console.error(error)
          reject(error)
        })
    })
  },
  obitLightCandle: function(data) {
    return new Promise((resolve, reject) => {
      lambda
        .post("light-candle", data)
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          console.error(error)
          reject(error)
        })
    })
  },
  verifyCaptcha: function(data) {
    return new Promise((resolve, reject) => {
      lambda
        .post("verify-captcha", data)
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getObituaries: function(data) {
    return new Promise((resolve, reject) => {
      lambda
        .get("get-obits")
        .then(res => {
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
